import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, MenuItem, Grid } from '@mui/material';
import {NOTIFICATION_TYPE, showNotificationBar} from '../../../actions/error-pages/NotificationBarActions';
import { LoadingButton, TextButton } from '../../common/StyledButtons';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { SUBMISSION_TYPES_HUMAN_MAP } from '../../../constants/Statuses';
import { StyledAutocomplete, StyledMultilineTextField, StyledTextField } from '../../common/StyledTextField';
import { StyledDropDown } from '../../common/StyledDropDown';
import { SUBMISSION_TYPES, postSubmission } from '../../../actions/external/SubmissionActions';
import { getAllSites } from '../../../selectors/AdminSelectors';
import StyledSwitch from '../../common/StyledSwitch';
import { getUserId } from '../../../selectors/UserSelectors';
import { getAllSubmissionsForAdmin } from '../../../actions/internal/AdminActions';
import { StyledDatePicker } from '../../common/StyledDatePicker';
import { STANDARD_PARAGRAPH_STYLE } from '../../../constants/Styles';
import { CHECK_IN_CYCLES } from '../../../constants/Common';
import { updateSiteInformation } from '../../../actions/internal/SiteActions';

const AdminManageSupportModal = ({ open, onClose, site }) => {

  const [ values, setValues ] = useState({ checkInDate: '', checkInCycle: '', checkInEligible: false });
  const [ errors, setErrors ] = useState([]);

  useEffect(() => {
    if (!site) return;
    const newVals = prepareValuesFromProps();
    setValues(newVals);
  }, [site])

  const [ isLoading, setIsLoading ] = useState(false);

  const prepareValuesFromProps = () => {
    const state = { checkInDate: '', checkInCycle: '', checkInEligible: false };
    if (site && site.site_service_modules && site.site_service_modules.support) {
      const { check_in_date_latest, check_in_cycle, check_in_eligible } =  site.site_service_modules.support;
      return { ...state, checkInDate: check_in_date_latest, checkInCycle: check_in_cycle, checkInEligible: check_in_eligible };
    }
    return state;
  }

  const setFieldValue = (id, value) => {
    setValues({ ...values, [id]: value })
  }

  const clearForm = () => {
    setErrors([]);
  }

  const handleClose = () => {
    clearForm();
    onClose();
  }

  const validateFields = () => {
    const errors = Object.keys(values).filter(key => values[key] === undefined || (typeof values[key] === 'string' && values[key].trim() === ''));
    // if (!selectedSiteId) errors.push('business');
    // if (!requestType) errors.push('requestType');
    return errors;
  }

  const handleSaveRequest = async () => {
    try {
      // validate payload
      const errors = validateFields();
      if (errors.length > 0) {
        setErrors(errors)
        return;
      }
      setIsLoading(true);

      const supportPayload = {
        check_in_date_latest: values.checkInDate,
        check_in_cycle: values.checkInCycle,
        check_in_eligible: values.checkInEligible
      }

      // MAKE CALL TO SAVE HERE
      await updateSiteInformation(site.site_id, getUserId(), ['support'], { support: supportPayload })

      showNotificationBar(NOTIFICATION_TYPE.SUCCESS, "This request has been created successfully!");
      clearForm();
      onClose();
    } catch(ex) {
      console.error(ex);
      showNotificationBar(NOTIFICATION_TYPE.ERROR, "An error has occurred while canceling this request. If this continues to happen, please contact us.");
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Dialog
          fullWidth
          open={open}
          maxWidth={'md'}
      >
          <DialogTitle>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Box>
                <h4 style={{ margin: 0, padding: 0 }}>Manage Support</h4>
                <p style={{ ...STANDARD_PARAGRAPH_STYLE }}>Please update the fields below accordingly to provide insight on the status of support with this business.</p>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', paddingTop: '20px' }}>
              <StyledDatePicker
                label="Last Check In Date"
                error={false}
                value={values.checkInDate}
                onChange={(newValue) => {
                  setFieldValue("checkInDate", newValue.valueOf());
                }}
              />
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <StyledDropDown
                    label="Check In Cycle"
                    value={values.checkInCycle}
                    onChange={(e) => setFieldValue("checkInCycle", e.target.value)}
                >
                    {Object.keys(CHECK_IN_CYCLES).map(key => (
                        <MenuItem
                            key={key}
                            value={key}
                        >
                            {CHECK_IN_CYCLES[key]}
                        </MenuItem>
                    ))}
                </StyledDropDown>
                </Grid>
                <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                  <StyledSwitch
                        title="Check In Eligible"
                        onChange={(e) => { setFieldValue('checkInEligible', e.target.checked) }}
                        checked={values.checkInEligible}
                    />
                </Grid>
            </Grid>
            
          </DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '16px'}}>
              <TextButton sx={{ marginRight: '10px' }} onClick={handleClose} disabled={isLoading}>Cancel</TextButton>
              <LoadingButton onClick={handleSaveRequest} isLoading={isLoading}>Save</LoadingButton>
            </Box>
      </Dialog>
    </>
  )
}

export default observer(withRouter(AdminManageSupportModal));
